// extracted by mini-css-extract-plugin
export default {"paginationContainer":"theme_paginationContainer__51n1U"};